import * as React from 'react';
import { cn } from '@/utils/utils';

// What sits over a 3D preview or a picture: readouts and small groups of controls, on the same translucent card surface
// as the overlay icon buttons (IconButton place="overlay").

/** A readout or label over a 3D preview (a size, a dimension, a region's name). */
export const OverlayLabel = React.forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement> & { muted?: boolean }>(
  ({ muted = false, className, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        'inline-flex items-center rounded-lureo-radius-pill bg-lureo-surface/90 px-2.5 py-1 font-lureo-font-ui text-lureo-12 font-medium leading-none tabular-nums shadow-lureo-shadow-control',
        muted ? 'text-lureo-ink-subtlest' : 'text-lureo-ink-subtle',
        className,
      )}
      {...props}
    />
  ),
);
OverlayLabel.displayName = 'OverlayLabel';

/** A small group of controls over a 3D preview, so they read against whatever is behind them. */
export const OverlayCard = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('inline-flex items-center gap-1 rounded-lureo-radius-pill bg-lureo-surface/90 p-1 shadow-lureo-shadow-control', className)} {...props} />
));
OverlayCard.displayName = 'OverlayCard';
